const workflowStepsMap = {
  collected_and_shipped: 1,
  delivered_to_vitaedna: 2,
  being_prepared: 3,
  being_analysed: 4,
  report_available: 5,
}
export default workflowStepsMap
